/*
 Created by qing 2020/2/18 6:23 下午
 */

import {
  FILTER_METHOD_TYPE__ALL,
  FILTER_METHOD_TYPE__EMPTY,
  FILTER_METHOD_TYPE__EQ,
  FILTER_METHOD_TYPE__GT,
  FILTER_METHOD_TYPE__GTE,
  FILTER_METHOD_TYPE__IN,
  FILTER_METHOD_TYPE__LIKE,
  FILTER_METHOD_TYPE__LT,
  FILTER_METHOD_TYPE__LTE,
  FILTER_METHOD_TYPE__NE,
  FILTER_METHOD_TYPE__NIN,
  FILTER_METHOD_TYPE__NOT_EMPTY,
  FILTER_METHOD_TYPE__RANGE,
  FILTER_METHOD_TYPE__UNLIKE
} from "../types"
import {FORM_ITEM__CHECKBOX} from "../../../RyForm/types";
import SelectValue from "../SelectValue"

export default {
  props: {
    formId: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      default: () => {}
    },
    fields: {
      type: Array,
      default: () => []
    },
    dropdownData: {
      type: Array,
      default: () => []
    },
    filter: {
      type: Object,
      default: () => {}
    },
    // 筛选的 value
    filterValue: {
      type: Array,
      default: () => []
    },
    // 是否为选择的
    filterWay: {
      type: Boolean,
      default: true
    },
    // 方法
    method: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否显示选择fixedValue
    fixedValue: {
      type: Boolean,
      default: true
    }
  },
  components: {
    SelectValue
  },
  data() {
    return {
      FILTER_METHOD_TYPE__ALL,
      FILTER_METHOD_TYPE__EMPTY,
      FILTER_METHOD_TYPE__EQ,
      FILTER_METHOD_TYPE__GT,
      FILTER_METHOD_TYPE__GTE,
      FILTER_METHOD_TYPE__IN,
      FILTER_METHOD_TYPE__LIKE,
      FILTER_METHOD_TYPE__LT,
      FILTER_METHOD_TYPE__LTE,
      FILTER_METHOD_TYPE__NE,
      FILTER_METHOD_TYPE__NIN,
      FILTER_METHOD_TYPE__NOT_EMPTY,
      FILTER_METHOD_TYPE__RANGE,
      FILTER_METHOD_TYPE__UNLIKE,

      current: this.filterValue,
    }
  },
  computed: {
    isHidden() {
      return this.method === FILTER_METHOD_TYPE__EMPTY || this.method === FILTER_METHOD_TYPE__NOT_EMPTY
    },
    isMultiple() {
      return this.method === FILTER_METHOD_TYPE__IN ||
        this.method === FILTER_METHOD_TYPE__NIN ||
        this.method === FILTER_METHOD_TYPE__LIKE ||
        this.method === FILTER_METHOD_TYPE__UNLIKE ||
        this.method === FILTER_METHOD_TYPE__ALL ||
        (this.filter.type === FORM_ITEM__CHECKBOX &&
          this.method === FILTER_METHOD_TYPE__EQ)
    },
    selectValue: {
      set(val) {
        if (this.isMultiple) {
          this.current.splice(0, this.current.length, ...val)
        } else {
          this.current[0] = val
        }
      },
      get() {
        if (this.isMultiple) {
          return this.current
        } else {
          return this.current[0]
        }
      }
    }
  },
  methods: {
    filterChange() {
      this.$emit('change')
    },
  }
}
